import { computed } from '@ember/object';
import { hasMany, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  name: attr(),
  endorserData: attr(),

  endorsements: hasMany('endorsement', { async: false }),

  count: computed('endorsements', function () {
    return this.get('endorsements.length');
  }),
});
